import { useEffect, useState, useMemo, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import { apiService } from "../../Axios/apiService"; 

import { ProjectFilters } from "./ProjectFilters";

export default function ListProjects() {
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [filters, setFilters] = useState({
        farm: "",
        referredBy: "",
        title: "",
        year: "",
        status: "Active",
    });

    // Load users
    const loadProjects = async (filterValues = filters) => {
        setLoading(true);
        console.log("loading projects...");

        apiService("get", `projects/?farm=${filters.farm}&title=${filters.title}&year=${filters.year}&status=${filters.status}&referredBy=${filters.referredBy}`, null,
            (response) => {
                console.log("Projects:", response);
                setProjects(response);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        )

    }

    // Initial load (no filters)
    useEffect(() => {
        loadProjects();
    }, []);


    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Projects <button className="btn-sm btn-primary" onClick={() => { navigate(`/Projects/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                            <ProjectFilters
                                filters={filters}
                                setFilters={setFilters}
                                onApply={() => loadProjects(filters)}
                            />


                        <table style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Farm</th>
                                    <th>Project</th>
                                    <th>Status</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {projects && (projects.map((project) => {
                                    return (
                                        <tr key={project.id} style={{ cursor: "pointer" }}>
                                            <td onClick={() => { navigate(`/Projects/View/${project.id}`) }}>{project.id}</td>
                                            <td>
                                                <a href="#" onClick={() => { navigate(`/Farms/View/${project.farm.id}`) }}>{project.farm.name}</a>
                                                {project.referredBy && (
                                                    <span style={{ color: "#a0a0a0" }}>
                                                        {" - "}{project.referredBy}
                                                    </span>
                                                )}

                                            </td>
                                            <td onClick={() => { navigate(`/Projects/View/${project.id}`) }}>{project.title} ({project.year})</td>
                                            <td onClick={() => { navigate(`/Projects/View/${project.id}`) }}>{project.status}</td>
                                            <td>
                                                <Link to={`/Projects/View/${project.id}`} className="btn-sm btn-primary">View</Link>
                                                <Link to={`/Projects/Edit/${project.id}`} className="btn-sm btn-other">Edit</Link>
                                            </td>
                                        </tr>
                                    )
                                }))}
                            
                            </tbody>
                        </table>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
